// The shared React Query hooks (packages/shared/src/hooks.ts), bound to this app's client and React Query.
import * as rq from "@tanstack/react-query";
import { createHooks, type Hooks } from "@pagemates/shared/hooks";
import { api } from "./api";

const hooks: Hooks = createHooks(api, rq);
export const useMe: Hooks["useMe"] = hooks.useMe;
export const useHealth: Hooks["useHealth"] = hooks.useHealth;
export const useClub: Hooks["useClub"] = hooks.useClub;
export const useClubBooks: Hooks["useClubBooks"] = hooks.useClubBooks;
export const useMembers: Hooks["useMembers"] = hooks.useMembers;
export const useDiscussion: Hooks["useDiscussion"] = hooks.useDiscussion;
export const useNotificationCount: Hooks["useNotificationCount"] = hooks.useNotificationCount;
export const useNotifications: Hooks["useNotifications"] = hooks.useNotifications;
export const useUpdateProgress: Hooks["useUpdateProgress"] = hooks.useUpdateProgress;
export const useAddComment: Hooks["useAddComment"] = hooks.useAddComment;
export const useEditComment: Hooks["useEditComment"] = hooks.useEditComment;
export const useDeleteComment: Hooks["useDeleteComment"] = hooks.useDeleteComment;
export const useMarkRead: Hooks["useMarkRead"] = hooks.useMarkRead;
